<template>
    <div class="hk-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'HomePage' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item v-for="(item, index) in links" :key="index">{{
                item.title
            }}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

<script>
export default {
    props: {
        links: {
            type: Array,
            required: true
        }
    },
    data() {
        return {};
    },
    created() {},
    mounted() {}
};
</script>
<style lang="scss" scoped>
.hk-breadcrumb {
    margin-bottom: 25px;
    ::v-deep {
        .el-breadcrumb {
            font-size: 16px;
        }
    }
}
</style>
